import React, { Component, Fragment } from 'react';
import cn from 'classnames';
import {
  shakeElement,
  validateEmail,
  isMobileSizeScreen,
  exposeComponentToGlobalScope,
} from '../../utils/utilsGlobal';

import services, { events } from '../../services/services';
import { LoadingScreen } from '../Loading';

import logo from '../../../public/assets/images/logo.svg';
import styles from './PageLogin.scss';
import uiStyles from '../../styles/ui.scss';


export class PageLogin extends Component {

  emailPasswordForm = React.createRef();

  state = {
    email: '',
    password: '',
    isCachePurged: false,
    hasCheckedIfLoggedIn: false,
  };

  componentDidMount() {
    services.userWatcher.on([events.USER_SET_SUCCESS, events.USER_SET_ERROR], () => {
      this.setState({ hasCheckedIfLoggedIn: true });
    });
    exposeComponentToGlobalScope(this);
  }

  onInputChange = (value, type) => {
    this.setState({
      [type]: value
    });
  };

  isLoginFormValid = () => {
    const { email, password } = this.state;
    if (!validateEmail(email.trim())) {
      return false;
    }
    else if (password.trim().length < 3) {
      return false;
    }
    return true;
  };

  onEmailPasswordSubmit = e => {
    const { email, password } = this.state;
    e.preventDefault();

    if (!this.isLoginFormValid()) {
      shakeElement(this.emailPasswordForm.current);
    }
    else {
      services.userWatcher.logIn(email.trim(), password.trim()).catch(() => {
        shakeElement(this.emailPasswordForm.current);
      });
    }
  };

  onPurgeCacheClick = () => {
    services.pwa.reset().finally(() => {
      this.setState({ isCachePurged: true });
      if (isMobileSizeScreen()) {
        location.reload(true); // Force refresh of mobile
      }
    });
  };

  render(){
    const { email, password, isCachePurged, hasCheckedIfLoggedIn } = this.state;

    if (!hasCheckedIfLoggedIn) {
      return (
        <LoadingScreen/>
      );
    }

    return (
      <Fragment>
        <div className={styles.container}>
          <div className={styles.form}>
            <img className={styles.logo} src={logo} alt="Эликсир"/>
            <h1 className={styles.title}>Эликсир</h1>

            <form onSubmit={this.onEmailPasswordSubmit} ref={this.emailPasswordForm}>
              <input className={styles.input}
                type="email"
                defaultValue={email}
                placeholder="Email"
                onChange={e => this.onInputChange(e.target.value, 'email')}/>
              <input className={styles.input}
                type="password"
                defaultValue={password}
                placeholder="Пароль"
                onChange={e => this.onInputChange(e.target.value, 'password')}/>
              <button className={cn(uiStyles.buttonDanger, styles.button)} type="submit">
                Войти
              </button>

            </form>

          </div>
        </div>
        {!isCachePurged && (
          <span className={styles.purgeCache} onClick={this.onPurgeCacheClick}>Сбросить кэш</span>
        )}
      </Fragment>
    );
  }
}
